import React, { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react'

import { Container, Row, Col, FormGroup, Label } from "reactstrap"
import { MesesPlanificacionHEDTO } from '../Planificacion Horas Extras/TypesPlanificacionUnidades';
import { InformacionSolicitudHEServidor, QueryEstructurasPersonalAdmHEDTO } from 'components/UsuarioGeneral/HorasExtras/SolicitudPagoHE/TypesSolicitudPagoHE';
import BuscadorServidor from './BuscadorServidor';
import SelectItem2 from 'components/Varios/SelectNew';
import { SelectCombo } from 'components/Types/GeneralTypes';
import { ObtenerAniosSolicitudHE, ObtenerInformacionIngresoSolicitud, ObtenerMesesSolicitudHE, ObtenerUnidadesConPresupuestoHE } from './ServicesSolicitudHEManual';
import { showAlert, showAlertAviso } from '../Parametros Horas Extras/Actividades/ActividadesHorasExtras';
import TablaSolicitudManualPagoHE from './TablaSolicitudManualPagoHE';
import Cargando from 'components/Varios/Cargando';
import { InformacionManualSolicitudPagoHE } from './TypesIngresoManualSolicHE';
import { ObtenerUnidadesPlanificacionHE, VistaPreviaSolicitudHEIngresada } from 'components/UsuarioGeneral/HorasExtras/SolicitudPagoHE/FunctionsSolicitudPagoHE';
import { GetDocumentVistaPrevia2 } from 'helpers/files';

import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos';
import ModalCargando from 'components/Varios/ModalCargando';
import { listadoMeses } from 'functions/DatesFunctions';
import DatePickerBlueColor from 'components/Varios/DatePicker/DatePickerBlueColor';
import Datepicker from 'components/Varios/Datepicker';

export default function SolicitudManualHE() {
    const TITULO_PANTALLA = `INGRESO MANUAL DE SOLICITUDES DE PAGO DE HORAS EXTRAS`;

    const [aniosPlanificacion, setAniosPlanificacion] = useState<number[]>([]);
    const [mesesPlanificacion, setMesesPlanificacion] = useState<MesesPlanificacionHEDTO[]>([]);
    const [unidadesPlanificacion, setUnidadesPlanificacion] = useState<QueryEstructurasPersonalAdmHEDTO[]>([]);

    const [fechaSolicitud, setfechaSolicitud] = useState<string>('');
    const [fechaFirmaDirect, setfechaFirmaDirect] = useState<string>('');

    const [anioSeleccionado, setAnioSeleccionado] = useState<number>(0);
    const [mesSeleccionado, setMesSeleccionado] = useState<number>(0);
    const [unidadSeleccionada, setUnidadSeleccionada] = useState<number>(0);

    const [datospersona, setdatospersona] = useState<string>("")

    const [otraunidadSeleccionada, setOtraunidadSeleccionada] = useState<number>(0);

    const [loadingValoresCampos, setloadingValoresCampos] = useState<boolean>(false)
    const [loading, setloading] = useState<boolean>(false)
    const [loadingDatosServidor, setloadingDatosServidor] = useState<boolean>(false)

    const [informacionServidor, setinformacionServidor] = useState<InformacionManualSolicitudPagoHE | undefined>(undefined)
    const [ServidorPuedeIngresar, setsetServidorPuedeIngresar] = useState<boolean>(true)
    const [urlDocumentoVP, seturlDocumentoVP] = useState<string>("")


    async function GenerarVistaPreviaSolicitudHE(idSolicitudHE: number) {
        setloading(true)

        const respuestaVistaPrevia = await VistaPreviaSolicitudHEIngresada(idSolicitudHE);

        if (respuestaVistaPrevia.status === 200 && respuestaVistaPrevia.dataResponse) {
            seturlDocumentoVP(respuestaVistaPrevia.dataResponse)
        }
        else {
            showAlert("No es posible cargar la vista previa del documento", false);
        }


        setloading(false)
    }


    async function OnClickDocumento(solicitud: InformacionSolicitudHEServidor | null) {
        if (solicitud === null) {
            return;
        }

        if (solicitud.refArchivo) {
            setloading(true)
            const url = await GetDocumentVistaPrevia2(solicitud.refArchivo)
            if (url) {
                seturlDocumentoVP(url)
            }
            setloading(false)
        }
        else {
            await GenerarVistaPreviaSolicitudHE(solicitud.idSolicitudHorasExtras)
        }
    }

    const handleChangeSelect = (setter: Dispatch<SetStateAction<number>>, name: string) => (value: string | number) => {


        if (name === "unidadnoplanificada") {
            setUnidadSeleccionada(0)
        }
        else if (name === "unidadplanificada") {
            setOtraunidadSeleccionada(0)
        }
        setter(Number(value));
    };


    function ObtenerOpcionesUnidades(listadoUnidades: QueryEstructurasPersonalAdmHEDTO[], planificaron: boolean) {
        var listadoOpciones: SelectCombo[] = [];
        if (listadoUnidades && listadoUnidades.length > 0) {
            //const filtrados = listadoUnidades.filter((u) => u.unidadPlanificada === planificaron);

            listadoOpciones = listadoUnidades.map((v, i) => { return { label: v.nombre, value: v.idestructuraorganica.toString() } })
        }
        return listadoOpciones;

    }

    async function ObtenerAniosSolicitudesHE() {
        setloading(true)
        const informacionGeneral = await ObtenerAniosSolicitudHE();
        if (informacionGeneral.status === 200 && informacionGeneral.dataResponse) {

            const aniosDisponibles: number[] = informacionGeneral.dataResponse;
            setAniosPlanificacion(aniosDisponibles)

        } else {
            setAniosPlanificacion([]); // Set an empty state
            showAlert("Ha ocurrido un inconveniente", false)
        }
        setloading(false)
    }

    async function ObtenerMesesSolicitudesHE(anioSeleccionado: number) {
        const informacionGeneral = await ObtenerMesesSolicitudHE(anioSeleccionado);
        if (informacionGeneral.status === 200) {

            const mesesDisponibles: MesesPlanificacionHEDTO[] = informacionGeneral.dataResponse;

            setMesesPlanificacion(mesesDisponibles)
            if (mesesDisponibles.length > 0) {
                const mapeados = mesesPlanificacion.map(mes => ({ value: mes.numeroMes, label: mes.nombreMes }))

                if (mesesDisponibles.length === 1) {
                    setMesSeleccionado(mesesDisponibles[0].numeroMes)
                }
                else {
                    setMesSeleccionado(mesesDisponibles[1].numeroMes)
                }

            }

        } else {
            setMesesPlanificacion([]); // Set an empty state
            showAlert("Ha ocurrido un inconveniente", false)
        }
    }

    async function ObtenerUnidadParaServidor(anioSeleccionado: number, mesSeleccionado: number, identificacion: string = "") {
        const informacionGeneral = await ObtenerUnidadesPlanificacionHE(anioSeleccionado, mesSeleccionado, identificacion);
        if (informacionGeneral.status === 200 && informacionGeneral.dataResponse && typeof informacionGeneral.dataResponse !== 'string') {


            //Se setea  por default la unidad del servidor o en la que ya se encuentre ingresada una solicitud de horas extras, que segun el servicio siempre deberia ser la primera cuando se consulta aquí.
            if (informacionGeneral.dataResponse && informacionGeneral.dataResponse.length > 0) {
                //setUnidadSeleccionada(informacionGeneral.dataResponse[0].idEstructuraOrganica)
                return informacionGeneral.dataResponse[0].idEstructuraOrganica;
            }

        }
        return 0;
    }

    async function ObtenerUnidadesSolicitudesHE(anioSeleccionado: number, mesSeleccionado: number, unidadSeleccionada: number, identificacionServidor: string) {
        setloadingValoresCampos(true)
        const datosUnidades = await ObtenerUnidadesConPresupuestoHE(anioSeleccionado, mesSeleccionado);
        if (datosUnidades.status === 200) {


            setUnidadesPlanificacion(datosUnidades.dataResponse)

            if (unidadSeleccionada === 0) {
                const unidadServidor = await ObtenerUnidadParaServidor(anioSeleccionado, mesSeleccionado, identificacionServidor);
                if (unidadServidor && unidadServidor > 0) {
                    setUnidadSeleccionada(unidadServidor)
                }
            }
            else{
                setloadingValoresCampos(false)
            }


        }
        else {
            showAlert("Ha ocurrido un inconveniente al obtener información sobre unidades disponibles", false)
        }
        setloadingValoresCampos(false)
    }

    async function ObtenerDatosServidorParaIngresoManual(anio: number, mes: number, unidad: number, identificacion: string) {
        setloadingDatosServidor(true)
        const datosServidor = await ObtenerInformacionIngresoSolicitud(anio, mes, unidad, identificacion);
        if (datosServidor.status === 200 && datosServidor.dataResponse) {
            var infoSolicitudAIngresar = datosServidor.dataResponse;

            // if (infoSolicitudAIngresar.actividadesPlanificadas.length > 0) {


                setinformacionServidor(datosServidor.dataResponse)

                var infoSolicitudIngresada = datosServidor.dataResponse.informacionSolicitud
                if (infoSolicitudIngresada !== null && !infoSolicitudIngresada.puedeSolicitar) {
                    showAlertAviso("Actualmente hay una solicitud en estado " + infoSolicitudIngresada.estadoDescripcion + " para el servidor. ")
                    setsetServidorPuedeIngresar(infoSolicitudIngresada.puedeSolicitar)



                }
                else {
                    setsetServidorPuedeIngresar(true)
                }
            // }
            // else {
            //     const nombreMes = listadoMeses[mes - 1].mes;
            //     showAlert(datosServidor.errorMessage ? datosServidor.errorMessage : `El servidor no ha sido planificado para laborar horas extras en el mes de ${nombreMes} o está en la unidad incorrecta`, false);
            //     setinformacionServidor(undefined)
            // }
        }
        else {
            showAlert(datosServidor.errorMessage ? datosServidor.errorMessage : "Ha ocurrido un inconveniente al obtener información del servidor", false);
            setinformacionServidor(undefined)
        }
        setloadingDatosServidor(false)
    }



    useEffect(() => {
        ObtenerAniosSolicitudesHE();
    }, [])

    useEffect(() => {
        if (anioSeleccionado === 0 && aniosPlanificacion.length > 0 && datospersona) {
            setAnioSeleccionado(aniosPlanificacion[0])
        }

    }, [aniosPlanificacion, datospersona, anioSeleccionado])


    useEffect(() => {
        if (anioSeleccionado > 0) {
            ObtenerMesesSolicitudesHE(anioSeleccionado)
        }
        else {
            if (aniosPlanificacion.length > 0) {
                // setAnioSeleccionado(aniosPlanificacion[0])
            }
        }


    }, [anioSeleccionado, aniosPlanificacion])


    useEffect(() => {
        if (anioSeleccionado > 0 && mesSeleccionado > 0 && datospersona && unidadSeleccionada === 0) {
            const [idpersona, identificacion, apellidos, nombres] = datospersona.split("|")
            ObtenerUnidadesSolicitudesHE(anioSeleccionado, mesSeleccionado, unidadSeleccionada, identificacion);
        }
    }, [anioSeleccionado, mesSeleccionado, unidadSeleccionada, datospersona])


    useEffect(() => {
        if (anioSeleccionado > 0 && mesSeleccionado > 0 && unidadSeleccionada > 0 && datospersona) {
            const [idpersona, identificacion, apellidos, nombres] = datospersona.split("|")
            ObtenerDatosServidorParaIngresoManual(anioSeleccionado, mesSeleccionado, unidadSeleccionada, identificacion);
        }
    }, [anioSeleccionado, mesSeleccionado, unidadSeleccionada, datospersona])

    const Refrescar = useCallback(
        async () => {
            const [idpersona, identificacion, apellidos, nombres] = datospersona.split("|")
            await ObtenerDatosServidorParaIngresoManual(anioSeleccionado, mesSeleccionado, unidadSeleccionada, identificacion);
        },
        [anioSeleccionado, mesSeleccionado, unidadSeleccionada, datospersona],
    )


    return (
        <div className='content'>
            <div>
                {TITULO_PANTALLA}
            </div>


            <Container fluid={true}>
                {

                    <BuscadorServidor
                        onChangePersona={(datosPersona: string) => setdatospersona(datosPersona)}
                    />
                }
                <Row className="mt-1 mb-1">
                    <Col xl={2}>
                        <FormGroup>
                            <Label for="anio">Año*</Label>
                            <SelectItem2
                                options={aniosPlanificacion.map(anio => ({ value: anio, label: anio }))}
                                placeholder=""
                                name="anio"
                                id="anio"
                                icon="fa-caret-down"
                                value={anioSeleccionado}
                                onChange={(v, n, t, l) => {
                                    setAnioSeleccionado(+v)
                                    setMesSeleccionado(0);
                                }
                                }
                            />
                        </FormGroup>
                    </Col>
                    <Col xl={1}>
                        <FormGroup>
                            <Label for="mes">Mes*</Label>
                            <SelectItem2
                                options={mesesPlanificacion.map(mes => ({ value: mes.numeroMes, label: mes.nombreMes }))}
                                placeholder=""
                                name="mes"
                                id="mes"
                                icon="fa-caret-down"
                                value={mesSeleccionado}
                                disabled = {loadingValoresCampos || loadingDatosServidor}
                                onChange={handleChangeSelect(setMesSeleccionado, "mes")}
                            />
                        </FormGroup>
                    </Col>

                    <Col xl={4}>
                        <FormGroup>
                            <Label for="mes">Unidad*</Label>
                            <SelectItem2
                                options={ObtenerOpcionesUnidades(unidadesPlanificacion, true)}
                                placeholder=""
                                name="unidadplanificada"
                                id="mes"
                                icon="fa-caret-down"
                                value={unidadSeleccionada}
                                disabled = {loadingValoresCampos || loadingDatosServidor}
                                onChange={handleChangeSelect(setUnidadSeleccionada, "unidadplanificada")}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row className="text-justify-center">
                    {anioSeleccionado > 0 && informacionServidor && mesSeleccionado > 0 && unidadSeleccionada > 0 && datospersona !== "" && !loadingDatosServidor && ServidorPuedeIngresar &&
                        (
                            <>
                                {/* <Col xl={12}>
                                    <Row>
                                        <Col xl={2}>
                                            <FormGroup>
                                                <Label for="mes">Fecha Solicitud*</Label>
                                                <DatePickerBlueColor
                                                    value={fechaSolicitud}
                                                    placeholderText={"seleccione fecha"}
                                                    onChange={(date) => {
                                                        if (!date) return;

                                                        const year = date.getFullYear();
                                                        const month = String(date.getMonth() + 1).padStart(2, '0');
                                                        const day = String(date.getDate() + 1).padStart(2, '0');

                                                        const fechaString = `${year}-${month}-${day}`;
                                                        setfechaSolicitud(fechaString);
                                                    }}
                                                    color="blue"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col xl={2}>
                                            <FormGroup>
                                                <Label for="mes">Fecha Firma Directivo*</Label>
                                                <DatePickerBlueColor
                                                    value={fechaFirmaDirect}
                                                    placeholderText={"seleccione fecha"}
                                                    onChange={(date) => {
                                                        if (!date) return;

                                                        const year = date.getFullYear();
                                                        const month = String(date.getMonth() + 1).padStart(2, '0');
                                                        const day = String(date.getDate() + 1).padStart(2, '0');

                                                        const fechaString = `${year}-${month}-${day}`;
                                                        setfechaFirmaDirect(fechaString);
                                                    }}
                                                    color="blue"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Col> */}
                                {
                                    <TablaSolicitudManualPagoHE
                                        feriados={informacionServidor.feriados}
                                        actividadesPlanificadas={informacionServidor.actividadesPlanificadas}
                                        anio={anioSeleccionado}
                                        mes={mesSeleccionado - 1}
                                        unidad={unidadSeleccionada}
                                        detalleDias={informacionServidor.horariosServidor}
                                        parametros={informacionServidor.parametros}
                                        usuarioidentificacion={datospersona.split("|")[1]}
                                        aprobadoresUnidad={informacionServidor.aprobadoresUnidad}
                                        contratolaboral={informacionServidor.idContrato}
                                        nombretabla={informacionServidor.nombreTabla}
                                        rows={informacionServidor.diasSolicitud}
                                        onSubirDocumentos={async () => await Refrescar()}
                                    />
                                }
                            </>
                        )
                    }
                    {
                        !ServidorPuedeIngresar && !loadingDatosServidor && !loading && informacionServidor && informacionServidor.informacionSolicitud !== null &&

                        <Col xl={10}>
                            <div className="text-center">
                                {"Actualmente hay una solicitud en estado " + '"' + informacionServidor.informacionSolicitud.estadoDescripcion + '" para el servidor .'}
                                <img
                                    src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                                    className="iconPDF"
                                    alt={`Solicitud de Pago de HE`}
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title={`Solicitud de Pago de HE`}
                                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                                    onClick={() => { OnClickDocumento(informacionServidor.informacionSolicitud) }}
                                />
                            </div>
                        </Col>


                    }
                    {
                        loadingDatosServidor &&

                        <Col xl={10}>
                            <Cargando
                                mensaje='Cargando información...'
                            />
                        </Col>




                    }
                    {
                        <ModalVistaPreviaDocumentos
                            show={loading || urlDocumentoVP !== ""}
                            cargandoDatos={loading}
                            size='xl'
                            tituloModal='Solicitud de Horas Extras'
                            onClose={() => seturlDocumentoVP("")}
                            urlArchivo={urlDocumentoVP}
                            allHeight={true}
                        />
                    }
                </Row>
                <ModalCargando
                    show={loadingValoresCampos}
                    onClose={() => setloadingValoresCampos(false)}
                    size='md'
                    textoCargando='Identificando unidad servidor...'
                />
            </Container>
        </div>

    )
}
